<template>
    <div>
        <Toast />
        <MenuComponent />

        <!-- Dialogo para confirmacion de cerrar  -->
        <Dialog modal :closable="false" v-model:visible="modal2">
            <br>
            <p class="tetx-12 text-center">¿Seguro de cerrar? La información se eleiminara y perderas tu progreso</p><br><br>
            <div class="cont-100 d-flex-f">
                <div class="cont-45 mr-auto">
                    <Button class="cont-100" label="Cancelar" @click="modal2 = false"
                                severity="secondary"></Button>
                </div>
                <div class="cont-45 mr-auto">
                    <Button class="cont-100" label="Confirmar" @click="ElimiarData"
                                severity="contrast"></Button>
                </div>
            </div>
        </Dialog>

        <Dialog class="modal-1" modal v-model:visible="modal" :closable="false" >
            <Button
                icon="pi pi-times"
                severity="secondary"
                @click="cerrarModal"
            />
            <div class=" cont-100 m-auto">
                <div class="contenedor1">
                    <p class="text-center text-10">Estado de registro</p>
                    <ProgressBar :value="valor">{{ valor }}%</ProgressBar>
                </div><br>
                <div v-show="section1 === true" class="contenedor1">
                    <div>
                        <p class="title-1">Registrar nueva empresa</p>
                        <p class="title-2">Rellena todos los campos para continuar</p>
                        <br>
                        <br>
                        <div>
                            <label for="">
                                <i class="pi pi-building blue"></i>
                                Detalle de la compañia
                            </label>
                        </div><br>
                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel class="w-full md:w-56" variant="on">
                                        <Select v-model="prospectoSeleccionado" :options="prospectos" filter optionLabel="Nombre"
                                            class="cont-100 " @change="CargarDatos">
                                        </Select>
                                        <label for="on_label">Selecciona un prospecto</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel class="w-full md:w-56" variant="on">
                                        <InputText id="on_label" v-model="razon_social" class="cont-100" />
                                        <label for="on_label">Razon Social</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>

                        <br>
                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="rfc" class="cont-100" />
                                        <label for="on_label">RFC</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="nombre_comercial" class="cont-100" />
                                        <label for="on_label">Nombre Comercial</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="content">
                            <div class="rw">
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="nombre_contacto" class="cont-100" />
                                        <label for="on_label">Nombre de contacto</label>
                                    </FloatLabel>
                                </div>
                                <div class="sup-2">
                                    <FloatLabel variant="in">
                                        <InputText id="on_label" v-model="correo" class="cont-100" />
                                        <label for="on_label">Correo Electrónico</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        </div>
                        <br>
                        <FloatLabel variant="in">
                            <MultiSelect v-model="empresa" :options="empresas"  optionValue="nombre" optionLabel="nombre" id="empresa_1"
                                filter :maxSelectedLabels="5" class="cont-100" />
                            <label for="empresa_1">Empresa con la que se ejecuta el servicio</label>
                        </FloatLabel>
                        <br>
                        <Button class="m-auto d-block cont-100" @click="cambiarRegistroDomicilio" label="Continuar"
                            severity="contrast" icon="pi pi-arrow-right" />
                    </div>
                </div>

                <div v-show="section2 === true" class="contenedor1">
                    <div>

                        <label for="">
                            <i class="pi pi-map-marker blue"></i>
                            Direccion
                        </label>
                    </div><br>
                    <div class="content">
                        <div class="rw">
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <InputText id="on_label" v-model="calle" class="cont-100" />
                                    <label for="on_label">Calle</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <InputText id="on_label" v-model="numero_int" class="cont-100" />
                                    <label for="on_label">Numero interior</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <InputText id="on_label" v-model="numero_ext" class="cont-100" />
                                    <label for="on_label">Numero exterior</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div><br>
                    <div class="content">
                        <div class="rw">
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <Select v-model="pais" :options="paises" optionLabel="nombre" id="pais" filter
                                        class="cont-100" />
                                    <label for="pais">Selecciona Pais</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <InputText id="codigo" v-model="codigo_postal" @change="consultarCodigo()"
                                        class="cont-100" />
                                    <label for="codigo">Codigo Postal</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-3">
                                <FloatLabel variant="in">
                                    <InputText id="localidad" v-model="localidad" class="cont-100" />
                                    <label for="localidad">Localidad</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="content">
                        <div class="rw">
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <Select v-model="colonia" :options="colonias" optionLabel="name" id="colonia" filter
                                        class="cont-100" />
                                    <label for="colonia">Selecciona una colonia</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <InputText id="esatdo" v-model="estado" class="cont-100" />
                                    <label for="estado">Estado</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div>
                    <br><br>
                    <div class="cont-100 d-flex-f">
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Regresar" @click="regresarSeccion1"
                                severity="secondary"></Button>
                        </div>
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Continuar" severity="contrast"
                                @click="cambiarDatosFiscales"></Button>
                        </div>
                    </div>

                </div>

                <div v-show="section3 === true" class="contenedor1">
                    <div>

                        <label for="">
                            <i class="pi pi-file blue"></i>
                            Informacíon fiscal
                        </label>
                    </div><br>
                    <div class="content">
                        <div class="rw">
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <Select v-model="regimen" :options="data_regimen" id="regimen" filter
                                        class="cont-100" :disabled="enableregimen">
                                        <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                {{ slotProps.value.Clave }} - {{ slotProps.value.Descripcion }}
                                            </span>
                                        </template>

                                        <!-- Lo que se muestra en la lista -->
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.Clave }} - {{ slotProps.option.Descripcion }}
                                            </div>
                                        </template>
                                    </Select>
                                    <label for="regimen">Selecciona regimen fiscal</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <Select v-model="uso_cfdi" :options="data_usocfdi" optionLabel="Descripcion"
                                        id="uso_cfdi" filter class="cont-100" :disabled="enableusocfdi">
                                        <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                {{ slotProps.value.Clave }} - {{ slotProps.value.Descripcion }}
                                            </span>
                                        </template>

                                        <!-- Lo que se muestra en la lista -->
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.Clave }} - {{ slotProps.option.Descripcion }}
                                            </div>
                                        </template>
                                    </Select>
                                    <label for="uso_cfdi">Selecciona uso de CFDI</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div>
                    <br>

                    <div class="content">
                        <div class="rw">
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <Select v-model="metodo_pago" @change="definirMetodo" :options="data_metodopago" optionLabel="Descripcion"
                                        id="metodo_pago" filter class="cont-100" :disabled="enableremetdo">
                                        <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                {{ slotProps.value.Clave }} - {{ slotProps.value.Descripcion }}
                                            </span>
                                        </template>

                                        <!-- Lo que se muestra en la lista -->
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.Clave }} - {{ slotProps.option.Descripcion }}
                                            </div>
                                        </template>
                                    </Select>
                                    <label for="metodo_pago">Selecciona método de pago</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <Select v-model="forma_pago" :options="data_formapago" optionLabel="Descripcion"
                                        id="forma_pago" filter class="cont-100" :disabled="enableforma">
                                        <template #value="slotProps">
                                            <span v-if="slotProps.value">
                                                {{ slotProps.value.Clave }} - {{ slotProps.value.Descripcion }}
                                            </span>
                                        </template>

                                        <!-- Lo que se muestra en la lista -->
                                        <template #option="slotProps">
                                            <div>
                                                {{ slotProps.option.Clave }} - {{ slotProps.option.Descripcion }}
                                            </div>
                                        </template>
                                    </Select>
                                    <label for="forma_pago">Selecciona forma de pago</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="content">
                        <div class="rw">
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <InputText id="txid" v-model="taxId" class="cont-100" :disabled="enbledtax"/>
                                    <label for="txid">TAX ID</label>
                                </FloatLabel>
                            </div>
                            <div class="sup-2">
                                <FloatLabel variant="in">
                                    <InputText id="dias" v-model="diasCredito" class="cont-100" />
                                    <label for="dias">Dias de Credito</label>
                                </FloatLabel>
                            </div>
                        </div>
                    </div><br>
                    <br>
                    <div class="cont-100 d-flex-f">
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Regresar" @click="regresarSeccion2"
                                severity="secondary"></Button>
                        </div>
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Continuar" severity="contrast"
                                @click="datosCompletos"></Button>
                        </div>
                    </div>
                </div>

                <div v-show="section4 === true" class="contenedor1">
                    <br><br>
                    <p class="text-center text-20">Datos completos</p>
                    <p class="text-center text-14">
                        Por favor revisa que todos los datos esten correctos, y que la informacion brindada
                        sea la que pertenece a la CSF.
                        <br>
                        <br>
                        Si todo esta correcto por favor da clic en registrar.
                    </p>
                    <br>
                    <div class="cont-100 d-flex-f">
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Regresar" @click="regresarSeccion3"
                                severity="secondary"></Button>
                        </div>
                        <div class="cont-45 mr-auto">
                            <Button class="cont-100" label="Registrar" severity="contrast"
                                @click="registrarCliente"></Button>
                        </div>
                    </div>
                </div>
            </div>

        </Dialog>

        <div class="wrap">
            <DataTable v-model:filters="model" :value="organizaciones" paginator :rows="7" dataKey="id"
                filterDisplay="row" :globalFilterFields="['Nombre', 'Razon_Social']">

                <template #header>
                    <div class="flex justify-between align-items-center">
                        <Button icon="pi pi-plus" label="Agregar Cliente" class="p-button-success mr-l-2"
                            @click="abrirRegistro" />
                    </div>
                </template>

                <Column header="Acciones" style="min-width: 10rem">
                    <template #body="{ data }">
                        <button v-tooltip.bottom="{
                            value: 'Ver Organizacion',
                            showDelay: 500,
                            hideDelay: 300,
                        }" class="button bg-hov-primary text-hov-white border-rad-2 mr-auto" style="width: 40px;"
                            @click="abrirCliente(data)">
                            <i class="pi pi-eye"></i>
                        </button>
                        
                    </template>
                </Column>

                <Column field="Nombre" header="Nombre" :sortable="true" style="min-width: 3rem" :filter="true"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por nombre" />
                    </template>
                </Column>


                <Column field="Razon_Social" :filter="true" header="Razon Social" style="min-width: 12rem">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por Razon social" />
                    </template>
                </Column>

                <Column field="RFC" header="RFC" :filter="true" :sortable="true" style="min-width: 3rem"
                    :showFilterMenu="false">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar por RFC" />
                    </template>
                </Column>

                <Column field="Email" header="Correo electronico" :filter="true" :sortable="true"
                    style="min-width: 3rem" :showFilterMenu="false">
                    <template #body="{ data }"> {{ data.Email }} </template>
                </Column>

            </DataTable>
        </div>
    </div>
</template>

<script setup>
import MenuComponent from '@/components/MenuComponent.vue';
import api from '@/plugins/Axios';
import { DataTable, Column, InputText, Button, Dialog, FloatLabel, Select, MultiSelect, Toast, useToast, ProgressBar } from 'primevue';
import { onMounted, ref, } from 'vue';
import { FilterMatchMode } from '@primevue/core/api';
import { useRouter } from 'vue-router';

const router = useRouter();
const enbledtax = ref(true);
const enableregimen = ref(false);
const enableusocfdi = ref(false);
const enableforma = ref(false);
const taxId =ref("");
const logistica =ref("");
const enableremetdo = ref(false);
const diasCredito = ref(0);
const prospectoSeleccionado = ref("");
const rfc = ref("");
const razon_social = ref("");
const nombre_comercial = ref("");
const empresa = ref("");
const nombre_contacto = ref("");
const valor = ref(0);
const correo = ref("");
const toast = useToast();
const prospectos = ref([]);
const codigo_postal = ref("");
const calle = ref("");
const numero_int = ref("");
const numero_ext = ref("");
const regimen = ref("");
const data_regimen = ref([]);
const uso_cfdi = ref("");
const data_usocfdi = ref([]);
const metodo_pago = ref("");
const idCliente = ref(0);
const data_metodopago = ref([
    {Descripcion:"Pago en parcialidades o diferido", Clave:"PPD"},
    {Descripcion:"Pago en una sola exhibicíon", Clave:"PUE"}
]);
const forma_pago = ref("");
const data_formapago = ref([]);
const pais = ref("");
const estado = ref("");
const localidad = ref("");
const colonia = ref("");
const organizaciones = ref([]);
const colonias = ref([]);
const section1 = ref(true);
const section2 = ref(false);
const section3 = ref(false);
const section4 = ref(false);
const modal = ref(false);
const modal2 = ref(false);
const empresas = ref([
    { nombre: "INTRA" },
    { nombre: "ICOLD" },
    { nombre: "EC" },
    { nombre: "TRANS" },
    { nombre: "VTS" }
])

const paises = ref([
    { nombre: "México", code: "mx" },
    { nombre: "Estados Unidos", code: "us" },
    { nombre: "Canada", code: "can" }
]);

const model = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
    RFC: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Razon_Social: { value: null, matchMode: FilterMatchMode.CONTAINS },
})


//#region Funciones Asincronas
const obtenerOrganizaciones = async () => {
    try {
        let form = new FormData();
        form.append("getClientes", "");
        const res = await api.post("/Api_Usuario", form);
        organizaciones.value = res.data.result;
    }
    catch (err) {
        console.error(err);
    }
}

const consultarCodigo = async () => {
    try {
        let url = "https://api.zippopotam.us/" + pais.value.code;
        const res = await api.get(url + "/" + codigo_postal.value);
        colonias.value = [];
        if (res.status === 200) {
            estado.value = res.data.places[0].state;
            for (let item of res.data.places) {
                colonias.value.push(
                    { "name": item["place name"] }
                )
            }
        }
        else {
            toast.add({ severity: 'error', summary: 'Error no se encuentra el dodigo', detail: "ingresa los datos manualmente", life: 3000 });
        }
    }
    catch (err) {
        console.error(err);
        toast.add({ severity: 'error', summary: 'Error en la peticion', detail: err.message + "\nErr message:  el codigo postal no existe", life: 5000 });
    }
}


const obtenerProspectos = async () => {
    try {
        let form = new FormData();
        form.append("getProspectos", "");
        const res = await api.post("/Api_Usuario", form);
        prospectos.value = res.data.result;
    }
    catch (err) {
        console.error(err);
    }
}

const LlenarCatalogos = async () => {
    try {
        const res = await api.get("/Api_Usuario?usocfdi");
        data_usocfdi.value = res.data;
        const res2 = await api.get("/Api_Usuario?regimenfiscal");
        console.log("result", res2.data)
        data_regimen.value = res2.data;
    }
    catch (err) {
        console.log(err)
    }
}

const LlamarMetodoPago = async() =>{
    try{
        const res = await api.get("/Api_Usuario?metodopago");
        data_formapago.value = res.data;
    }
    catch(err)
    {
        console.error(err);
    }
}

const registrarCliente = async () =>{
    try
    {
        let form = new FormData();
        console.log(colonia.value)
        form.append("regimen", regimen.value.Clave);
        form.append("forma", forma_pago.value.Clave);
        form.append("metodo", metodo_pago.value.Clave);
        form.append("cfdi", uso_cfdi.value.Clave);
        form.append("Nombre_Comercial", nombre_comercial.value);
        form.append("Nombre_Completo", nombre_contacto.value);
        form.append("numero_int", numero_int.value);
        form.append("numero_ext", numero_ext.value);
        form.append("id_cliente", idCliente.value);
        form.append("RFC", rfc.value);
        form.append("Correo", correo.value);
        form.append("Ciudad", localidad.value);
        form.append("Estado", estado.value);
        form.append("Calle", calle.value);
        form.append("Colonia", colonia.value.name);
        form.append("Password", "N/A");
        form.append("Logistica", logistica.value);
        form.append("Empresas", empresa.value.join());
        form.append("Clave", '');
        form.append("Pais", pais.value.code.toUpperCase());
        form.append("CP", codigo_postal.value);
        form.append("archivo", null);
        form.append("Razon_Social", razon_social.value);
        form.append("taxId", taxId.value);
        form.append("diasCredito", diasCredito.value);
        form.append("registrarCliente", "");
        const res = await api.post("/Api_Usuario", form);
        if(res.data.message ==="success")
        {
            ElimiarData();
            toast.add({ severity: 'success', summary: 'Completo', detail: "La organizacion se registro correctamente", life: 3000 });
            obtenerOrganizaciones();
        }
        else
        {
            toast.add({ severity: 'error', summary: 'Error', detail: res.data.message, life: 3000 });
        }
    }
    catch(err)
    {
        console.error(err);
        toast.add({ severity: 'error', summary: 'Error', detail: err, life: 3000 });
    }
}


//#endregion


//#region Funciones dinamicas

const cambiarRegistroDomicilio = () => {
    if (nombre_comercial.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes dejar el campo Nombre comercial vacío", life: 3000 });
        return;
    }
    if (rfc.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes dejar el campo RFC vacío", life: 3000 });
        return;
    }
    if (razon_social.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes dejar el campo  Razon Social vacío", life: 3000 });
        return;
    }
    if (correo.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes dejar el campo Correo vacío", life: 3000 });
        return;
    }
    if (empresa.value.length === 0) {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin al menos seleccionar una empresa para ejecutar", life: 3000 });
        return;
    }
    section1.value = false;
    section2.value = true;
    valor.value = 30;
}

const cambiarDatosFiscales = () => {
    if (calle.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin colocar la calle", life: 3000 });
        return;
    }
    if (numero_ext.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin colocar un numero", life: 3000 });
        return;
    }
    if (colonia.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin seleccionar la colonia", life: 3000 });
        return;
    }
    if (pais.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin seleccionar el pais", life: 3000 });
        return;
    }
    if (localidad.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin seleccionar la localidad o cuidad", life: 3000 });
        return;
    }
    if (codigo_postal.value === "") {
        toast.add({ severity: 'warn', summary: 'Advertencia', detail: "No puedes avanzar sin colocar el codigo postal", life: 3000 });
        return;
    }
    console.log(rfc.value)
    if (rfc.value === "XEXX010101000") {
        regimen.value = {
            Clave:616,
            Descripcion:"Sin obligaciones fiscales",
            Id:13
        };
        uso_cfdi.value = {
            Clave:"G03",
            Descripcion:"Gastos en general",
            Id:3
        };
        metodo_pago.value={
            Clave:"PPD",
            Descripcion:"Pago en parcialidades o diferido"
        }
        forma_pago.value = {
            Id: 22, 
            Descripcion:"Por definir", 
            Clave:"99"
        }
        enbledtax.value = false;
        enableforma.value = true;
        enableregimen.value = true;
        enableremetdo.value = true;
        enableusocfdi.value = true;
    }
    else
    {
        regimen.value = null;
        uso_cfdi.value = null;
        metodo_pago.value = null;
        forma_pago.value = null;
        enbledtax.value = true;
        enableforma.value = false;
        enableregimen.value = false;
        enableremetdo.value = false;
        enableusocfdi.value = false;
    }
    section2.value = false;
    section3.value = true;
    valor.value = 70;

}

const datosCompletos = () =>{
    section3.value = false;
    section4.value = true; 
    valor.value = 100;
}

const abrirRegistro = () => {
    modal.value = true;
}

const CargarDatos = () => {
    let data = prospectoSeleccionado.value;
    console.log(data)
    razon_social.value = data.Razon_Social;
    rfc.value = data.RFC;
    correo.value = data.Email;
    nombre_comercial.value = data.Nombre;
    nombre_contacto.value = data.Apellido_Paterno;
    logistica.value = data.logistica;
    idCliente.value = data.Id;
}

const regresarSeccion1 = () => {
    section1.value = true;
    section2.value = false;
}


const regresarSeccion2 = () => {
    section2.value = true;
    section3.value = false;
}

const regresarSeccion3 = () => {
    section3.value = true;
    section4.value = false;
}


const definirMetodo = ()=>{
    data_formapago.value = [];
    if(metodo_pago.value.Clave ==="PPD")
    {
        data_formapago.value.push({
            Id: 22, 
            Descripcion:"Por definir", 
            Clave:"99"
        });
    }
    else
    {
        LlamarMetodoPago();
    }
}

const cerrarModal = ()=>{
    modal2.value = true;
}

const ElimiarData =()=>{
    rfc.value = "";
    razon_social.value = "";
    nombre_comercial.value = "";
    nombre_contacto.value = "";
    empresa.value = null;
    calle.value = "";
    numero_ext.value = "";
    numero_int.value = "";
    colonia.value = null;
    pais.value = null;
    localidad.value = null;
    prospectoSeleccionado.value = null;
    correo.value = "";
    estado.value = "";
    codigo_postal.value = "";
    regimen.value = null;
    uso_cfdi.value = null;
    metodo_pago.value = null;
    forma_pago.value = null;
    enbledtax.value = true;
    enableforma.value = false;
    enableregimen.value = false;
    enableremetdo.value = false;
    enableusocfdi.value = false;
    taxId.value = "";
    diasCredito.value = "";
    valor.value = 0;
    section1.value = true;
    section2.value = false;
    section3.value = false;
    section4.value = false;
    modal.value = false;
    modal2.value = false;
    taxId.value = "";
    diasCredito.value = "";
}

const abrirCliente = (data)=>{
    console.log(data)
    router.push({ name: 'organizacionvista', params: { id: data.Id } })
}

//#endregion


onMounted(() => {
    obtenerOrganizaciones();
    obtenerProspectos();
    LlenarCatalogos();
});
</script>


<style scoped>
.blue {
    color: rgb(0, 92, 192)
}

.title-1 {
    font-size: 1.2rem;
}

.title-2 {
    font-size: 0.9rem;
    color: silver;
}

.contenedor1 {
    width: 90%;
    margin: auto;
}



@media(max-width:1024px) {
    .contenedor1 {
        width: 100%;
        margin: auto;
    }

    .contenedor2 {
        width: 100%;
        margin: auto;
    }
}
</style>